// extracted by mini-css-extract-plugin
module.exports = {"root":"NoJS-module__root___y0-FC"};